import { getBond } from '../selectors';

export const calculateCuts = (productMol, substrateMols, productToMap, mapToSubstrates) => {
  const cuts = [];
  for (const bond of Object.values(productMol.bonds)) {
    const startMap = productToMap[Number(bond.start)];
    const endMap = productToMap[Number(bond.end)];
    if (mapToSubstrates[startMap] == null && mapToSubstrates[endMap] == null) {
      continue;
    }
    if (mapToSubstrates[startMap] == null || mapToSubstrates[endMap] == null) {
      cuts.push(bond.idx);
      continue;
    }
    const [startSubsId, startAtomId] = mapToSubstrates[startMap];
    const [endSubsId, endAtomId] = mapToSubstrates[endMap];
    if (startSubsId !== endSubsId) {
      cuts.push(bond.idx);
    } else if (getBond(substrateMols[startSubsId], startAtomId.toString(), endAtomId.toString()) == null) {
      cuts.push(bond.idx);
    }
  }
  return cuts;
};

export const applyCutsToDrawing = (drawing, cuts) => {
  for (const bond of Object.values(drawing.bonds)) {
    if (cuts.includes(bond.idx)) {
      bond.cut = {};
    }
  }
};
